import { render } from "./QuestionView.vue?vue&type=template&id=36dcf535"
import script from "./QuestionView.vue?vue&type=script&lang=js"
export * from "./QuestionView.vue?vue&type=script&lang=js"

import "./QuestionView.vue?vue&type=style&index=0&id=36dcf535&lang=css"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\divindenduitkering_toets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__